module.exports = __webpack_public_path__ + "img/fourday_ps_21.d98b1220.jpg";